// extracted by mini-css-extract-plugin
module.exports = {"root":"Minicart_root__2fGWM","minicart_icon":"Minicart_minicart_icon__2Q1K8","count":"Minicart_count__2xwGE"};